export default __webpack_public_path__ + "static/media/nike_stimuli_phone.a1653116.mp4";